// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__11GTj","subheader":"styles_subheader__lCqAQ","tour_btn":"styles_tour_btn__1EcbH","question":"styles_question__cl7PD"};